import { connect } from 'react-redux';
import { setCurrentTab } from 'store/siteCoordinator/siteCoordinator.actions';
import {
    viewPodCastStart,
    fetchPodCastEpisodeStart,
    fetchApplePodcastEpisodeStart,
    fetchListenNotesPodcastEpisodeStart,
} from 'store/podcast/podcast.actions';
import {
    podcastHeartStart,
    removeFavoritePodcastStart,
} from 'store/userHistoryPodcast/userHistoryPodcast.actions';
import { showSnackbarNotification } from 'store/notification/notification.actions';

const mapStateToProps = (state) => ({
    podcastState: state.podcast,
    searchRadioState: state.searchRadio,
    userHistoryPodcastState: state.userhistoryPodcast
});

const mapDispatchToProps = (dispatch) => ({
    onSetCurrentTab: (value) => dispatch(setCurrentTab(value)),
    onViewPodCastStart: (value) => dispatch(viewPodCastStart(value)),
    onFetchPodCastEpisode: (podcastId) => dispatch(fetchPodCastEpisodeStart(podcastId)),
    onFetchApplePodcastEpisode: (value) => dispatch(fetchApplePodcastEpisodeStart(value)),
    onFetchListenNotesPodcastEpisode: (value) => dispatch(fetchListenNotesPodcastEpisodeStart(value)),
    onFavouritePodcast: (id) => dispatch(podcastHeartStart(id)),
    onRemovePodcastHeartStart: (id) => dispatch(removeFavoritePodcastStart(id)),
    onShowSnackbarNotification: (message) =>
        dispatch(showSnackbarNotification(message))
});

const container = connect(mapStateToProps, mapDispatchToProps);

export default container;
